import { Action } from '@ngrx/store';
import {MapFilterActions, MapFilterActionTypes} from '../actions/map-filter.actions';


export interface State {
  mapOptions: number;
  statusOptions: number;
  groupOptions: number;
}

export const initialState: State = {
  mapOptions: -1,
  statusOptions: -1,
  groupOptions: -1
};

export function reducer(state = initialState, action: MapFilterActions): State {
  switch (action.type) {
    case MapFilterActionTypes.SelectMapFilters:
      return {...state,
        mapOptions: action.payload.mapOptions,
        statusOptions: action.payload.statusOptions,
        groupOptions: action.payload.groupOptions
      };
    default:
      return state;
  }
}
